import {
    useCallback,
} from 'react'
import {
    useTranslation,
} from 'react-i18next'

const useGetUntypedEnumLabel = () => {
    const {
        t,
    } = useTranslation()

    return useCallback((key) => {
        // If a key is not found in enumsLabels.json,
        // a message will be logged to the console in debug mode.
        const label = t(key, {
            ns: 'enums',
        })

        return label
    }, [t])
}

export default useGetUntypedEnumLabel
